import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const TelegramIcon = ({ className, fill = 'currentColor', ...props }: React.ComponentProps<'svg'>) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={mergeClassNames('w-[20px] h-[20px]', className)}
        {...props}
    >
        <g clipPath="url(#clip0_1742_13609)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.3584 7.38295C9.38571 7.78751 7.44178 8.62484 4.52658 9.89494C4.05319 10.0832 3.80521 10.2674 3.78264 10.4474C3.74449 10.7518 4.1256 10.8716 4.64457 11.0348C4.71516 11.057 4.7883 11.08 4.86328 11.1043C5.37386 11.2703 6.06069 11.4645 6.41774 11.4722C6.74162 11.4792 7.10311 11.3457 7.5022 11.0716C10.226 9.23301 11.632 8.30368 11.7203 8.28365C11.7825 8.26951 11.8688 8.25174 11.9273 8.30371C11.9858 8.35568 11.98 8.45411 11.9738 8.48051C11.9361 8.64146 10.4401 10.0323 9.66593 10.752C9.42458 10.9764 9.25339 11.1355 9.2184 11.1719C9.14 11.2533 9.0601 11.3303 8.98332 11.4043C8.50897 11.8616 8.15326 12.2045 9.00301 12.7645C9.41136 13.0336 9.73813 13.2561 10.0641 13.4781C10.4201 13.7206 10.7752 13.9624 11.2347 14.2636C11.3517 14.3403 11.4635 14.42 11.5724 14.4976C11.9867 14.793 12.359 15.0584 12.8188 15.016C13.086 14.9914 13.3621 14.7402 13.5022 13.9908C13.8335 12.2198 14.4847 8.38256 14.6352 6.80132C14.6484 6.66278 14.6318 6.48548 14.6185 6.40765C14.6051 6.32982 14.5773 6.21893 14.4761 6.13684C14.3563 6.03962 14.1714 6.01912 14.0886 6.02058C13.7125 6.0272 13.1355 6.22786 10.3584 7.38295Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1742_13609">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default TelegramIcon;